<template>
  <div style="height: 100%">
    <p>选好起点，剩下站点由近到远智能排序</p>
    <ul id="autoStation">
      <li
        @click="now = index"
        v-for="(item, index) in list"
        :key="index"
        :class="{ active: now == index }"
      >
        {{ item.name }}
      </li>
    </ul>
    <Button type="primary" long @click="paixu">智能排序</Button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      zhineng: false,
      nowStation: "",
      list: [],
      now: 0,
    };
  },
  methods: {
    reach(v) {
      this.list = v;
    },

    paixu() {
      if (!(this.list.length >= 2 && this.list.length <= 16)) {
        this.$Message.error("只允许2-16个点");
        return;
      }
      var list = this.list;
      var arr = [];
      for (let i = 0; i < list.length; i++) {
        if (i == this.now) {
          arr.unshift(list[i]);
        } else {
          arr.push(list[i]);
        }
      }
      this.utils.loading(this, "排序中");
      var item = {
        orgCoord: 2,
        pointList: arr,
        sortType: 1, //0-直线距离，1-驾车导航距离，3-步行规划距离
      };
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-common-server-lbs/lbs/sort",
        data: item,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载

        var data = res.data.data;
        this.zhengli(data);
      });
    },
    zhengli(data) {
      var list = this.list;
      for (let i = 0; i < list.length; i++) {
        for (let j = 0; j < data.length; j++) {
          if (data[j].x == list[i].x) {
            data[j] = list[i];
          }
        }
      }

      //this.list = data;
      this.$emit('result',data)
    },
  },
};
</script>
<style>
#autoStation {
  width: 100%;
  height: calc(100% - 70px);
  margin-bottom: 6px;
  overflow: auto;
  margin-top: 10px;
}
#autoStation li {
  width: 100%;
  line-height: 34px;
  background-image: linear-gradient(to bottom, #f3f3f3, #ffffff, #eaeaea);
  border-radius: 10px;
  padding-left: 10px;
  cursor: pointer;
}
#autoStation li.active {
  background-image: linear-gradient(to bottom, #26dc87, #19c555, #35e375);
  color: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/components/tangci/autoSet.vue